<template>
  <div>
    <el-input
      v-model="searchInput"
      placeholder="搜索部門名稱"
      size="small"
      suffix-icon="el-icon-search"
      @input="inputchange"/>
    <div
      v-loading="loading"
      class="search-list">
      <el-breadcrumb
        style="padding: 5px 0;"
        separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="(item, index) in breadcrumbList"
          :key="index">
          <a
            href="javascript:;"
            @click="breadcrumbBtn(item, index)">{{ item.label }}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <flexbox
        v-for="(item, index) in showlist"
        v-if="item.show"
        :key="index"
        class="stru-list">
        <el-checkbox
          v-model="item.isCheck"
          :disabled="item.disabled"
          class="stru-check"
          @change="checkChange(item, index)"/>
        <div
          class="stru-name"
          @click="enterChildren(item)">{{ item.name }}</div>
        <div
          v-if="item.children"
          class="el-icon-arrow-right stru-enter"/>
      </flexbox>
    </div>
  </div>
</template>
<script type="text/javascript">
import { depList } from '@/api/common'

export default {
  name: 'XhStructure', // 新建 structure
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    /** 多選框 只能選一個 */
    radio: {
      type: Boolean,
      default: false
    },
    /** 已選資訊 */
    selectedData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      breadcrumbList: [], // 麵包屑數據
      selectItems: [], // 選擇項
      showlist: [], // 展示數據
      loading: false, // 載入動畫
      searchInput: ''
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.selectItems = this.selectedData
    // 部門列表數據
    this.getStructureList()
  },
  methods: {
    // 部門列表數據
    getStructureList() {
      this.loading = true
      depList({
        type: 'tree'
      })
        .then(res => {
          this.showlist = this.addIsCheckProp(res.data)
          this.breadcrumbList.push({ label: '全部', data: this.showlist })

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 麵包屑點選事件
    breadcrumbBtn(item, index) {
      if (this.radio && this.selectItems.length == 1) return
      if (index + 1 <= this.breadcrumbList.length - 1) {
        this.breadcrumbList.splice(index + 1, this.breadcrumbList.length - 1)
      }
      this.showlist = []
      this.showlist = this.handelCheck(item.data)
    },
    // 點選checkbox選中
    checkChange(item, aindex) {
      this.$set(this.showlist, aindex, item)
      var removeIndex = -1
      for (let index = 0; index < this.selectItems.length; index++) {
        const element = this.selectItems[index]
        if (item.id == element.id) {
          removeIndex = index
        }
      }
      if (removeIndex == -1 && item.isCheck) {
        this.selectItems.push(item)
      } else if (removeIndex != -1) {
        this.selectItems.splice(removeIndex, 1)
      }

      /** 單選邏輯 */
      if (this.radio) {
        if (item.isCheck) {
          this.showlist = this.showlist.map(function(element, index, array) {
            if (element.id == item.id) {
              element.disabled = false
            } else {
              element.disabled = true
            }
            return element
          })
        } else {
          this.showlist = this.showlist.map(function(item, index, array) {
            item.disabled = false
            return item
          })
        }
      }

      this.$emit('changeCheckout', { data: this.selectItems })
    },
    /** 數據重新重新整理時 循環標記展示陣列 */
    handelCheck(list) {
      var self = this
      list = list.map(function(item, index, array) {
        item.isCheck = self.selectItemsHasItem(item)
        return item
      })
      this.inputchange()
      return list
    },
    selectItemsHasItem(item) {
      if (this.selectItems.length == 0) {
        return false
      }
      var hasItem = false
      for (let index = 0; index < this.selectItems.length; index++) {
        const element = this.selectItems[index]
        if (item.id == element.id) {
          hasItem = true
          break
        }
      }
      return hasItem
    },
    /**  */
    /** 點選進入子陣列 */
    enterChildren(item) {
      // 保證單選環境下 沒有選中 才可進入children
      if (item.children && !(this.radio && this.selectItems.length == 1)) {
        this.showlist = []
        this.showlist = this.handelCheck(this.addIsCheckProp(item.children))
        this.breadcrumbList.push({ label: item.label, data: this.showlist })
      }
    },
    /** 給預設數據加isCheck屬性 */
    addIsCheckProp(list) {
      if (list.length > 0) {
        var item = list[0]
        if (item.hasOwnProperty('isCheck')) {
          return list
        } else {
          return list.map(function(item, index, array) {
            item.disabled = false
            item.isCheck = false
            item.show = true
            return item
          })
        }
      }
      return list
    },
    // 父元件 選中
    parentRemoveCheck(data) {
      this.selectItems = data.data
      var temps = this.showlist
      this.showlist = []
      this.showlist = this.handelCheck(temps)
      /** 單選邏輯 */
      if (this.radio) {
        this.showlist = this.showlist.map(function(item, index, array) {
          item.disabled = false
          return item
        })
      }
    },
    /** 搜索 */
    inputchange(val) {
      this.showlist = this.showlist.map(function(item, index, array) {
        if (item.name.indexOf(val) != -1) {
          item.show = true
        } else {
          item.show = false
        }
        return item
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search-list {
  padding: 5px;
  height: 248px;
  overflow: auto;
}
.stru-list {
  padding: 5px;
  font-size: 13px;
  .stru-check {
    margin-right: 8px;
  }
  .stru-name {
    flex: 1;
  }
  .stru-enter {
    margin-right: 8px;
  }
}
</style>
